import { CRMAPIBase } from '@api/crmApiBase';
import { ScheduleExceptionTypeListResp } from '@api/responseModels/worker/schedule/scheduleExceptionTypeListResponse';
import { ScheduleExceptionTypeResp } from '@api/responseModels/worker/schedule/scheduleExceptionTypeResponse';
import { TScheduleExceptionType } from '@components/schedule/common/types';

class ScheduleExceptionTypeGroup extends CRMAPIBase {
    async saveScheduleExceptionType(et: TScheduleExceptionType) {
        const result = await this.post<ScheduleExceptionTypeResp>('/schedule-exception-types', {
            ...et,
        });
        return result;
    }

    async getScheduleExceptionType(crm_id: number, id: number) {
        const result = await this.get<ScheduleExceptionTypeResp>(
            `/schedule-exception-types/${id}`,
            {
                crm_id,
            }
        );
        return result;
    }

    async getScheduleExceptionTypeList() {
        const result = await this.get<ScheduleExceptionTypeListResp>('/schedule-exception-types');
        return result;
    }

    async updateScheduleExceptionType(et: TScheduleExceptionType) {
        const result = await this.put<ScheduleExceptionTypeResp>(
            `/schedule-exception-types/${et.id}`,
            {
                ...et,
            }
        );
        return result;
    }

    async removeScheduleExceptionType(crm_id: number, id: number) {
        const result = await this.delete<ScheduleExceptionTypeResp>(
            `/schedule-exception-types/${id}`,
            {
                crm_id,
            }
        );
        return result;
    }

    async restoreScheduleExceptionType(crm_id: number, id: number) {
        const result = await this.post<ScheduleExceptionTypeResp>(
            `/schedule-exception-types/${id}/restore`,
            {
                crm_id,
            }
        );
        return result;
    }
}

export { ScheduleExceptionTypeGroup };
